import { render, staticRenderFns } from "./StrategySummary.vue?vue&type=template&id=fe612d3e&scoped=true&"
import script from "./StrategySummary.vue?vue&type=script&lang=ts&"
export * from "./StrategySummary.vue?vue&type=script&lang=ts&"
import style0 from "./StrategySummary.vue?vue&type=style&index=0&id=fe612d3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe612d3e",
  null
  
)

export default component.exports